// src/api/tableApi.ts

import { Paginator } from '@/models/globalModels';
import { FilterObj, TableIdEnum, TableOptions } from '@/models/tableModels';

import { api } from '../api';

const urls = {
  tableContent: '/tables/content',
  tableOptions: '/tables/options',
};

export const getTableContent = <TData>(
  table: TableIdEnum,
  filterObj?: FilterObj,
  httpMethod: 'get' | 'post' = 'post',
  customEndpoint?: string,
  queryFilters?: Record<string, string>,
) => {
  const query = queryFilters ? `?${new URLSearchParams(queryFilters).toString()}` : '';
  const endpoint = customEndpoint || `${urls.tableContent}/${table}/${query}`;

  return httpMethod === 'post'
    ? api.post<Paginator<TData>>(endpoint, filterObj)
    : api.get<Paginator<TData>>(endpoint, { params: { ...filterObj, ordering: filterObj?.ordering?.[0] } });
};

export const getTableOptions = (table: TableIdEnum, httpMethod: 'get' | 'post' = 'get', customEndpoint?: string) => {
  const endpoint = customEndpoint || `${urls.tableOptions}/${table}/`;

  return httpMethod === 'post' ? api.post<TableOptions>(endpoint) : api.get<TableOptions>(endpoint);
};
